export default "__VITE_ASSET__CI2ITlqB__"